import React, { useEffect, useState } from 'react';
import { api } from '../../lib/api';

export default function AdminReports() {
  const [r, setR] = useState(null);
  useEffect(() => { api.get('/admin/reports').then(x => setR(x.data)); }, []);
  if (!r) return <div><span className="ap-loader" /></div>;

  return (
    <div data-testid="admin-reports">
      <h2 className="mb-3">Reports</h2>
      <div className="row g-3">
        <div className="col-lg-6">
          <div className="ap-card">
            <h4>Businesses by city</h4>
            <ul className="list-unstyled">
              {r.by_city.map((x,i) => <li key={i} className="d-flex justify-content-between border-bottom py-2"><span>{x.name}</span><strong>{x.c}</strong></li>)}
            </ul>
          </div>
        </div>
        <div className="col-lg-6">
          <div className="ap-card">
            <h4>Businesses by category</h4>
            <ul className="list-unstyled">
              {r.by_category.map((x,i) => <li key={i} className="d-flex justify-content-between border-bottom py-2"><span>{x.name}</span><strong>{x.c}</strong></li>)}
            </ul>
          </div>
        </div>
        <div className="col-lg-6">
          <div className="ap-card">
            <h4>Enquiries by status</h4>
            <ul className="list-unstyled">
              {r.enquiry_by_status.map((x,i) => <li key={i} className="d-flex justify-content-between border-bottom py-2"><span>{x.status}</span><strong>{x.c}</strong></li>)}
            </ul>
          </div>
        </div>
        <div className="col-lg-6">
          <div className="ap-card">
            <h4>Top businesses by views</h4>
            <ul className="list-unstyled">
              {r.top_businesses.map((x,i) => <li key={i} className="d-flex justify-content-between border-bottom py-2"><a href={`/business/${x.slug}`}>{x.name}</a><strong>{x.views}</strong></li>)}
            </ul>
          </div>
        </div>
      </div>
    </div>
  );
}
